import React, { Component } from "react";
import ContactMeForm from '../ContactMe/ContactMeForm/ContactMeForm'



class ContactMe extends Component {

  render() { 
    return (
     <div>
        <ContactMeForm />
     </div>
    );
  }
}

export default ContactMe;